// Lib
import { get, isEmpty } from 'lodash/fp';

// Utils
import { getDisplayName, getEmail, getFamilyName, getGivenName } from '../../../../../common/users/userHelper';
import { prop } from '../../../../../common/utils/immutableHelper';

const rankUser = (searchValue) => {
    const value = searchValue.toLowerCase();

    return (user) => {
        let score = 0;

        const displayName = (getDisplayName(user) || '').toLowerCase();
        const givenName = (getGivenName(user) || '').toLowerCase();
        const familyName = (getFamilyName(user) || '').toLowerCase();
        const email = (getEmail(user) || '').toLowerCase();

        if (givenName.indexOf(value) === 0) {
            score += 5;
        }

        if (displayName.indexOf(value) === 0) {
            score += 2;
        }

        if (familyName.indexOf(value) === 0) {
            score += 5;
        }

        if (email.indexOf(value) !== -1) {
            score += 1;
        }

        return {
            user,
            score,
        };
    };
};

const getShareCount = (user) => prop('shareCount', user) || 0;

const shareCountComparator = (userA, userB) => getShareCount(userB) - getShareCount(userA);

const mostSharedUsers = (possibleSuggestions) => possibleSuggestions.sort(shareCountComparator).slice(0, 5);

const scoreComparator = (userA, userB) => {
    const result = userB.score - userA.score;

    if (result !== 0) return result;

    return shareCountComparator(userA, userB);
};

export default ({ searchTerm, possibleSuggestions }) => {
    if (isEmpty(searchTerm)) return mostSharedUsers(possibleSuggestions);

    const rankedSuggestions = possibleSuggestions.map(rankUser(searchTerm));
    return rankedSuggestions
        .filter((rankedSuggestion) => rankedSuggestion.score > 0)
        .sort(scoreComparator)
        .slice(0, 4)
        .map(get('user'));
};
